module.exports = __webpack_public_path__ + "img/default-header.51324ea9.png";